export default __webpack_public_path__ + "static/media/SPD.f29bd091.svg";